import { addEventListener, removeEventListener, getBreakpoint } from './utils'
import { load } from './app/loader'

export function bootstrap(): void {
    if (!window.dwc.bootstrap) {
        window.dwc = {
            load,
            breakpoint: 'mobile',
            bootstrap: false,
            loading: false,
            loaded: false,
            ready: () => {}
        }
    }

    if (window.dwc.bootstrap) {
        return
    }

    const handleResize = debounce(() => {
        const newBreakpoint = getBreakpoint()
        if (newBreakpoint === window.dwc.breakpoint) {
            return
        }

        window.dwc.breakpoint = newBreakpoint
        console.info(`DWC Loader: breakpoint change detection, projects will be reloaded.`)

        // Empty the container div
        const container = document.querySelector('.nespresso-container')
        if (container) {
            container.innerHTML = ''
        }

        void window.dwc.load(true)
    })

    addEventListener('resize', handleResize)
    addEventListener('beforeunload', () => {
        removeEventListener('resize', handleResize)
    })

    window.dwc.bootstrap = true
}

function debounce(func: () => void, timeout = 300): () => void {
    let timer: any
    return () => {
        clearTimeout(timer)
        timer = setTimeout(func, timeout)
    }
}
